import { CHECK_CIRCLE_V2, CLOCK_ICON, FLAG_BANNER_ICON, XERROR_ICON } from './images';
import { TRANSLATIONS_REQUESTS } from '../translations/requests';

export const REQUEST_TYPE_UNSUBSCRIBE = 'UNSUBSCRIBE';

export const FLEXIBLE_REMUNERATION_REQUEST_STATUS = {
  active: {
    text: TRANSLATIONS_REQUESTS.table.status.active,
    tagVariant: 'success-inverse',
    tagVariantTable: 'success',
    icon: CHECK_CIRCLE_V2,
    value: 'active'
  },
  pending: {
    text: TRANSLATIONS_REQUESTS.table.status.pending,
    tagVariant: 'inactive-inverse',
    tagVariantTable: 'inactive',
    icon: CLOCK_ICON,
    value: 'pending'
  },
  cancelled: {
    text: TRANSLATIONS_REQUESTS.table.status.cancelled,
    tagVariant: 'inactive-inverse',
    tagVariantTable: 'inactive',
    icon: FLAG_BANNER_ICON,
    value: 'cancelled'
  },
  rejected: {
    text: TRANSLATIONS_REQUESTS.table.status.rejected,
    tagVariant: 'error-inverse',
    tagVariantTable: 'error',
    icon: XERROR_ICON,
    value: 'rejected'
  }
};

export const FLEXIBLE_REMUNERATION_REQUESTS_TRAINING_TYPES = {
  course: 'course',
  material: 'material'
};

export const FLEXIBLE_REMUNERATION_REQUESTS_CATEGORIES = {
  training: 'training',
  health: 'health'
};

export const FLEXIBLE_REMUNERATION_REQUESTS_SKU = {
  training: 'flexible-remuneration-training',
  health: 'flexible-remuneration-health'
};

export const BETTERFLY_SUPPORT_LINK =
  'https://intercom.help/betterfly-support/es/collections/11319992-portal-de-clientes';

export const HOW_DISCOUNTS_WORK_LINK =
  'https://intercom.help/betterfly-support/es/articles/12885335-guia-y-reglas-para-la-solicitud-de-reembolsos-metlife-y-vida-security';

export const HOW_TO_USE_MEDISMART_LINK =
  'https://intercom.help/betterfly-support/es/articles/10516319-como-utilizar-el-beneficio-de-telemedicina-con-medismart';

export const FLEXIBLE_REMUNERATION_REJECT_REASONS = {
  salaryPercentageExceeded: 'SALARY_PERCENTAGE_EXCEEDED',
  accumulationLimitExceeded: 'ACCUMULATION_LIMIT_EXCEEDED',
  smiThresholdViolation: 'SMI_THRESHOLD_VIOLATION'
} as const;
